import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { useOpenXAgentContext } from '../../../context/useOpenXAgentContext';
import { AGENT_TOOL_IDS } from '../agentsConfig';
import type { OpenXAgentId, OpenXAgentSession } from '../types';
import { OpenXAgentHistory } from './OpenXAgentHistory';
import { OpenXAgentSwitcher } from './OpenXAgentSwitcher';

type OpenXAgentMenuMainScreenProps = {
  sessions?: OpenXAgentSession[];
};

export const OpenXAgentMenuMainScreen = ({ sessions = [] }: OpenXAgentMenuMainScreenProps) => {
  const { setIsMenuOpen, setActiveToolId } = useOpenXAgentContext();

  const handleAgentSelect = (agentId: OpenXAgentId) => {
    setActiveToolId(AGENT_TOOL_IDS[agentId]);
    setIsMenuOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, pt: '10px', pb: 2, px: 1 }}>
      <OpenXAgentSwitcher onAgentSelect={handleAgentSelect} />
      <Divider sx={{ my: 1 }} />
      <OpenXAgentHistory sessions={sessions} />
    </Box>
  );
};
